import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=5d6883f5"
import script from "./BrandList.vue?vue&type=script&lang=ts"
export * from "./BrandList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports